/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseError } from '../types';
// @ts-ignore
import type { GetPublishedWidgetData200Response } from '../types';
// @ts-ignore
import type { LegacyWarningsData } from '../types';
// @ts-ignore
import type { Location } from '../types';
// @ts-ignore
import type { MapLayerData } from '../types';
// @ts-ignore
import type { Page } from '../types';
// @ts-ignore
import type { PublishedDashboard } from '../types';
// @ts-ignore
import type { PublishedNavigationElement } from '../types';
// @ts-ignore
import type { PublishedWidget } from '../types';
/**
 * PublishedApi - axios parameter creator
 * @export
 */
export const PublishedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Shows the data based on legacy warnings settings for a published Dashboard.
         * @summary Show legacy warnings data for published Dashboard
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegacyWarningsDataForPublishedDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getLegacyWarningsDataForPublishedDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/published/dashboards/{dashboard_id}/legacy_warnings_data`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all Locations for a published Dashboard.
         * @summary List all Locations for published Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsForPublishedDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getLocationsForPublishedDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/published/dashboards/{dashboard_id}/locations`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all navigation elements for a published dashboard.
         * @summary List all navigation elements for published dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationElementsForPublishedDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getNavigationElementsForPublishedDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/published/dashboards/{dashboard_id}/navigation_elements`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the latest published version of a page for a dashboard
         * @summary Find page for published dashboard by ID
         * @param {string} dashboardId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageForPublishedDashboard: async (dashboardId: string, pageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getPageForPublishedDashboard', 'dashboardId', dashboardId)
            // verify required parameter 'pageId' is not null or undefined
            assertParamExists('getPageForPublishedDashboard', 'pageId', pageId)
            const localVarPath = `/published/dashboards/{dashboard_id}/pages/{page_id}`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)))
                .replace(`{${"page_id"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all active, published dashboards that are part of the current extranet, and that are accessible to the current user, ordered by name.
         * @summary List all accesible dashboards for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedDashboards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/published/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for the latest published version of a MapLayer
         * @summary Get data for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} timeStart 
         * @param {string} timeEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedMapLayerData: async (dashboardId: string, mapLayerId: string, timeStart: string, timeEnd: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getPublishedMapLayerData', 'dashboardId', dashboardId)
            // verify required parameter 'mapLayerId' is not null or undefined
            assertParamExists('getPublishedMapLayerData', 'mapLayerId', mapLayerId)
            // verify required parameter 'timeStart' is not null or undefined
            assertParamExists('getPublishedMapLayerData', 'timeStart', timeStart)
            // verify required parameter 'timeEnd' is not null or undefined
            assertParamExists('getPublishedMapLayerData', 'timeEnd', timeEnd)
            const localVarPath = `/published/dashboards/{dashboard_id}/map_layers/{map_layer_id}/data`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)))
                .replace(`{${"map_layer_id"}}`, encodeURIComponent(String(mapLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timeStart !== undefined) {
                localVarQueryParameter['time_start'] = timeStart;
            }

            if (timeEnd !== undefined) {
                localVarQueryParameter['time_end'] = timeEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get legend graphic (image)
         * @summary Get legend graphic for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} [dimensionTime] Required depending on layer
         * @param {string} [dimensionReferenceTime] Required depending on layer
         * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
         * @param {string} [dimensionLevel] Required depending on layer
         * @param {string} [dimensionRiskProfile] Required depending on layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedMapLayerLegendGraphic: async (dashboardId: string, mapLayerId: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getPublishedMapLayerLegendGraphic', 'dashboardId', dashboardId)
            // verify required parameter 'mapLayerId' is not null or undefined
            assertParamExists('getPublishedMapLayerLegendGraphic', 'mapLayerId', mapLayerId)
            const localVarPath = `/published/dashboards/{dashboard_id}/map_layers/{map_layer_id}/legend`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)))
                .replace(`{${"map_layer_id"}}`, encodeURIComponent(String(mapLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dimensionTime !== undefined) {
                localVarQueryParameter['dimension_time'] = dimensionTime;
            }

            if (dimensionReferenceTime !== undefined) {
                localVarQueryParameter['dimension_reference_time'] = dimensionReferenceTime;
            }

            if (dimensionAircraftHeightAboveGroundLevelInFt !== undefined) {
                localVarQueryParameter['dimension_aircraft_height_above_ground_level_in_ft'] = dimensionAircraftHeightAboveGroundLevelInFt;
            }

            if (dimensionLevel !== undefined) {
                localVarQueryParameter['dimension_level'] = dimensionLevel;
            }

            if (dimensionRiskProfile !== undefined) {
                localVarQueryParameter['dimension_risk_profile'] = dimensionRiskProfile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns data for the latest published version of a widget
         * @summary Get data for widget by ID
         * @param {string} dashboardId 
         * @param {string} widgetId 
         * @param {string} [locationId] 
         * @param {string} [timeStart] 
         * @param {string} [timeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedWidgetData: async (dashboardId: string, widgetId: string, locationId?: string, timeStart?: string, timeEnd?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getPublishedWidgetData', 'dashboardId', dashboardId)
            // verify required parameter 'widgetId' is not null or undefined
            assertParamExists('getPublishedWidgetData', 'widgetId', widgetId)
            const localVarPath = `/published/dashboards/{dashboard_id}/widgets/{widget_id}/data`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)))
                .replace(`{${"widget_id"}}`, encodeURIComponent(String(widgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (timeStart !== undefined) {
                localVarQueryParameter['time_start'] = timeStart;
            }

            if (timeEnd !== undefined) {
                localVarQueryParameter['time_end'] = timeEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the latest published version of a widget for a dashboard
         * @summary Find widget for published dashboard by ID
         * @param {string} dashboardId 
         * @param {string} widgetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetForPublishedDashboard: async (dashboardId: string, widgetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getWidgetForPublishedDashboard', 'dashboardId', dashboardId)
            // verify required parameter 'widgetId' is not null or undefined
            assertParamExists('getWidgetForPublishedDashboard', 'widgetId', widgetId)
            const localVarPath = `/published/dashboards/{dashboard_id}/widgets/{widget_id}`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)))
                .replace(`{${"widget_id"}}`, encodeURIComponent(String(widgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get WMS tile
         * @summary Get WMS tile for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} crs 
         * @param {string} bbox 
         * @param {string} width 
         * @param {string} height 
         * @param {string} [dimensionTime] Required depending on layer
         * @param {string} [dimensionReferenceTime] Required depending on layer
         * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
         * @param {string} [dimensionLevel] Required depending on layer
         * @param {string} [dimensionRiskProfile] Required depending on layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet: async (dashboardId: string, mapLayerId: string, crs: string, bbox: string, width: string, height: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet', 'dashboardId', dashboardId)
            // verify required parameter 'mapLayerId' is not null or undefined
            assertParamExists('publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet', 'mapLayerId', mapLayerId)
            // verify required parameter 'crs' is not null or undefined
            assertParamExists('publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet', 'crs', crs)
            // verify required parameter 'bbox' is not null or undefined
            assertParamExists('publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet', 'bbox', bbox)
            // verify required parameter 'width' is not null or undefined
            assertParamExists('publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet', 'width', width)
            // verify required parameter 'height' is not null or undefined
            assertParamExists('publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet', 'height', height)
            const localVarPath = `/published/dashboards/{dashboard_id}/map_layers/{map_layer_id}/wms_tile`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)))
                .replace(`{${"map_layer_id"}}`, encodeURIComponent(String(mapLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (crs !== undefined) {
                localVarQueryParameter['crs'] = crs;
            }

            if (bbox !== undefined) {
                localVarQueryParameter['bbox'] = bbox;
            }

            if (width !== undefined) {
                localVarQueryParameter['width'] = width;
            }

            if (height !== undefined) {
                localVarQueryParameter['height'] = height;
            }

            if (dimensionTime !== undefined) {
                localVarQueryParameter['dimension_time'] = dimensionTime;
            }

            if (dimensionReferenceTime !== undefined) {
                localVarQueryParameter['dimension_reference_time'] = dimensionReferenceTime;
            }

            if (dimensionAircraftHeightAboveGroundLevelInFt !== undefined) {
                localVarQueryParameter['dimension_aircraft_height_above_ground_level_in_ft'] = dimensionAircraftHeightAboveGroundLevelInFt;
            }

            if (dimensionLevel !== undefined) {
                localVarQueryParameter['dimension_level'] = dimensionLevel;
            }

            if (dimensionRiskProfile !== undefined) {
                localVarQueryParameter['dimension_risk_profile'] = dimensionRiskProfile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublishedApi - functional programming interface
 * @export
 */
export const PublishedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublishedApiAxiosParamCreator(configuration)
    return {
        /**
         * Shows the data based on legacy warnings settings for a published Dashboard.
         * @summary Show legacy warnings data for published Dashboard
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLegacyWarningsDataForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegacyWarningsData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLegacyWarningsDataForPublishedDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublishedApi.getLegacyWarningsDataForPublishedDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all Locations for a published Dashboard.
         * @summary List all Locations for published Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationsForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Location>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationsForPublishedDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublishedApi.getLocationsForPublishedDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all navigation elements for a published dashboard.
         * @summary List all navigation elements for published dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNavigationElementsForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublishedNavigationElement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNavigationElementsForPublishedDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublishedApi.getNavigationElementsForPublishedDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the latest published version of a page for a dashboard
         * @summary Find page for published dashboard by ID
         * @param {string} dashboardId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageForPublishedDashboard(dashboardId: string, pageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Page>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPageForPublishedDashboard(dashboardId, pageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublishedApi.getPageForPublishedDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all active, published dashboards that are part of the current extranet, and that are accessible to the current user, ordered by name.
         * @summary List all accesible dashboards for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishedDashboards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublishedDashboard>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishedDashboards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublishedApi.getPublishedDashboards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns data for the latest published version of a MapLayer
         * @summary Get data for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} timeStart 
         * @param {string} timeEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishedMapLayerData(dashboardId: string, mapLayerId: string, timeStart: string, timeEnd: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MapLayerData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishedMapLayerData(dashboardId, mapLayerId, timeStart, timeEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublishedApi.getPublishedMapLayerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get legend graphic (image)
         * @summary Get legend graphic for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} [dimensionTime] Required depending on layer
         * @param {string} [dimensionReferenceTime] Required depending on layer
         * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
         * @param {string} [dimensionLevel] Required depending on layer
         * @param {string} [dimensionRiskProfile] Required depending on layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishedMapLayerLegendGraphic(dashboardId: string, mapLayerId: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishedMapLayerLegendGraphic(dashboardId, mapLayerId, dimensionTime, dimensionReferenceTime, dimensionAircraftHeightAboveGroundLevelInFt, dimensionLevel, dimensionRiskProfile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublishedApi.getPublishedMapLayerLegendGraphic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns data for the latest published version of a widget
         * @summary Get data for widget by ID
         * @param {string} dashboardId 
         * @param {string} widgetId 
         * @param {string} [locationId] 
         * @param {string} [timeStart] 
         * @param {string} [timeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishedWidgetData(dashboardId: string, widgetId: string, locationId?: string, timeStart?: string, timeEnd?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublishedWidgetData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishedWidgetData(dashboardId, widgetId, locationId, timeStart, timeEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublishedApi.getPublishedWidgetData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the latest published version of a widget for a dashboard
         * @summary Find widget for published dashboard by ID
         * @param {string} dashboardId 
         * @param {string} widgetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetForPublishedDashboard(dashboardId: string, widgetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishedWidget>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetForPublishedDashboard(dashboardId, widgetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublishedApi.getWidgetForPublishedDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get WMS tile
         * @summary Get WMS tile for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} crs 
         * @param {string} bbox 
         * @param {string} width 
         * @param {string} height 
         * @param {string} [dimensionTime] Required depending on layer
         * @param {string} [dimensionReferenceTime] Required depending on layer
         * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
         * @param {string} [dimensionLevel] Required depending on layer
         * @param {string} [dimensionRiskProfile] Required depending on layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet(dashboardId: string, mapLayerId: string, crs: string, bbox: string, width: string, height: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet(dashboardId, mapLayerId, crs, bbox, width, height, dimensionTime, dimensionReferenceTime, dimensionAircraftHeightAboveGroundLevelInFt, dimensionLevel, dimensionRiskProfile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublishedApi.publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublishedApi - factory interface
 * @export
 */
export const PublishedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublishedApiFp(configuration)
    return {
        /**
         * Shows the data based on legacy warnings settings for a published Dashboard.
         * @summary Show legacy warnings data for published Dashboard
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegacyWarningsDataForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<LegacyWarningsData> {
            return localVarFp.getLegacyWarningsDataForPublishedDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all Locations for a published Dashboard.
         * @summary List all Locations for published Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Location>> {
            return localVarFp.getLocationsForPublishedDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all navigation elements for a published dashboard.
         * @summary List all navigation elements for published dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationElementsForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PublishedNavigationElement>> {
            return localVarFp.getNavigationElementsForPublishedDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the latest published version of a page for a dashboard
         * @summary Find page for published dashboard by ID
         * @param {string} dashboardId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageForPublishedDashboard(dashboardId: string, pageId: string, options?: RawAxiosRequestConfig): AxiosPromise<Page> {
            return localVarFp.getPageForPublishedDashboard(dashboardId, pageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all active, published dashboards that are part of the current extranet, and that are accessible to the current user, ordered by name.
         * @summary List all accesible dashboards for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedDashboards(options?: RawAxiosRequestConfig): AxiosPromise<Array<PublishedDashboard>> {
            return localVarFp.getPublishedDashboards(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for the latest published version of a MapLayer
         * @summary Get data for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} timeStart 
         * @param {string} timeEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedMapLayerData(dashboardId: string, mapLayerId: string, timeStart: string, timeEnd: string, options?: RawAxiosRequestConfig): AxiosPromise<MapLayerData> {
            return localVarFp.getPublishedMapLayerData(dashboardId, mapLayerId, timeStart, timeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Get legend graphic (image)
         * @summary Get legend graphic for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} [dimensionTime] Required depending on layer
         * @param {string} [dimensionReferenceTime] Required depending on layer
         * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
         * @param {string} [dimensionLevel] Required depending on layer
         * @param {string} [dimensionRiskProfile] Required depending on layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedMapLayerLegendGraphic(dashboardId: string, mapLayerId: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getPublishedMapLayerLegendGraphic(dashboardId, mapLayerId, dimensionTime, dimensionReferenceTime, dimensionAircraftHeightAboveGroundLevelInFt, dimensionLevel, dimensionRiskProfile, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns data for the latest published version of a widget
         * @summary Get data for widget by ID
         * @param {string} dashboardId 
         * @param {string} widgetId 
         * @param {string} [locationId] 
         * @param {string} [timeStart] 
         * @param {string} [timeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedWidgetData(dashboardId: string, widgetId: string, locationId?: string, timeStart?: string, timeEnd?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPublishedWidgetData200Response> {
            return localVarFp.getPublishedWidgetData(dashboardId, widgetId, locationId, timeStart, timeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the latest published version of a widget for a dashboard
         * @summary Find widget for published dashboard by ID
         * @param {string} dashboardId 
         * @param {string} widgetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetForPublishedDashboard(dashboardId: string, widgetId: string, options?: RawAxiosRequestConfig): AxiosPromise<PublishedWidget> {
            return localVarFp.getWidgetForPublishedDashboard(dashboardId, widgetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get WMS tile
         * @summary Get WMS tile for MapLayer by ID
         * @param {string} dashboardId 
         * @param {string} mapLayerId 
         * @param {string} crs 
         * @param {string} bbox 
         * @param {string} width 
         * @param {string} height 
         * @param {string} [dimensionTime] Required depending on layer
         * @param {string} [dimensionReferenceTime] Required depending on layer
         * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
         * @param {string} [dimensionLevel] Required depending on layer
         * @param {string} [dimensionRiskProfile] Required depending on layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet(dashboardId: string, mapLayerId: string, crs: string, bbox: string, width: string, height: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet(dashboardId, mapLayerId, crs, bbox, width, height, dimensionTime, dimensionReferenceTime, dimensionAircraftHeightAboveGroundLevelInFt, dimensionLevel, dimensionRiskProfile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublishedApi - object-oriented interface
 * @export
 * @class PublishedApi
 * @extends {BaseAPI}
 */
export class PublishedApi extends BaseAPI {
    /**
     * Shows the data based on legacy warnings settings for a published Dashboard.
     * @summary Show legacy warnings data for published Dashboard
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedApi
     */
    public getLegacyWarningsDataForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return PublishedApiFp(this.configuration).getLegacyWarningsDataForPublishedDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all Locations for a published Dashboard.
     * @summary List all Locations for published Dashboard by ID
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedApi
     */
    public getLocationsForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return PublishedApiFp(this.configuration).getLocationsForPublishedDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all navigation elements for a published dashboard.
     * @summary List all navigation elements for published dashboard by ID
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedApi
     */
    public getNavigationElementsForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return PublishedApiFp(this.configuration).getNavigationElementsForPublishedDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the latest published version of a page for a dashboard
     * @summary Find page for published dashboard by ID
     * @param {string} dashboardId 
     * @param {string} pageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedApi
     */
    public getPageForPublishedDashboard(dashboardId: string, pageId: string, options?: RawAxiosRequestConfig) {
        return PublishedApiFp(this.configuration).getPageForPublishedDashboard(dashboardId, pageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all active, published dashboards that are part of the current extranet, and that are accessible to the current user, ordered by name.
     * @summary List all accesible dashboards for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedApi
     */
    public getPublishedDashboards(options?: RawAxiosRequestConfig) {
        return PublishedApiFp(this.configuration).getPublishedDashboards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for the latest published version of a MapLayer
     * @summary Get data for MapLayer by ID
     * @param {string} dashboardId 
     * @param {string} mapLayerId 
     * @param {string} timeStart 
     * @param {string} timeEnd 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedApi
     */
    public getPublishedMapLayerData(dashboardId: string, mapLayerId: string, timeStart: string, timeEnd: string, options?: RawAxiosRequestConfig) {
        return PublishedApiFp(this.configuration).getPublishedMapLayerData(dashboardId, mapLayerId, timeStart, timeEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get legend graphic (image)
     * @summary Get legend graphic for MapLayer by ID
     * @param {string} dashboardId 
     * @param {string} mapLayerId 
     * @param {string} [dimensionTime] Required depending on layer
     * @param {string} [dimensionReferenceTime] Required depending on layer
     * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
     * @param {string} [dimensionLevel] Required depending on layer
     * @param {string} [dimensionRiskProfile] Required depending on layer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedApi
     */
    public getPublishedMapLayerLegendGraphic(dashboardId: string, mapLayerId: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options?: RawAxiosRequestConfig) {
        return PublishedApiFp(this.configuration).getPublishedMapLayerLegendGraphic(dashboardId, mapLayerId, dimensionTime, dimensionReferenceTime, dimensionAircraftHeightAboveGroundLevelInFt, dimensionLevel, dimensionRiskProfile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns data for the latest published version of a widget
     * @summary Get data for widget by ID
     * @param {string} dashboardId 
     * @param {string} widgetId 
     * @param {string} [locationId] 
     * @param {string} [timeStart] 
     * @param {string} [timeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedApi
     */
    public getPublishedWidgetData(dashboardId: string, widgetId: string, locationId?: string, timeStart?: string, timeEnd?: string, options?: RawAxiosRequestConfig) {
        return PublishedApiFp(this.configuration).getPublishedWidgetData(dashboardId, widgetId, locationId, timeStart, timeEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the latest published version of a widget for a dashboard
     * @summary Find widget for published dashboard by ID
     * @param {string} dashboardId 
     * @param {string} widgetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedApi
     */
    public getWidgetForPublishedDashboard(dashboardId: string, widgetId: string, options?: RawAxiosRequestConfig) {
        return PublishedApiFp(this.configuration).getWidgetForPublishedDashboard(dashboardId, widgetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get WMS tile
     * @summary Get WMS tile for MapLayer by ID
     * @param {string} dashboardId 
     * @param {string} mapLayerId 
     * @param {string} crs 
     * @param {string} bbox 
     * @param {string} width 
     * @param {string} height 
     * @param {string} [dimensionTime] Required depending on layer
     * @param {string} [dimensionReferenceTime] Required depending on layer
     * @param {string} [dimensionAircraftHeightAboveGroundLevelInFt] Required depending on layer
     * @param {string} [dimensionLevel] Required depending on layer
     * @param {string} [dimensionRiskProfile] Required depending on layer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishedApi
     */
    public publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet(dashboardId: string, mapLayerId: string, crs: string, bbox: string, width: string, height: string, dimensionTime?: string, dimensionReferenceTime?: string, dimensionAircraftHeightAboveGroundLevelInFt?: string, dimensionLevel?: string, dimensionRiskProfile?: string, options?: RawAxiosRequestConfig) {
        return PublishedApiFp(this.configuration).publishedDashboardsDashboardIdMapLayersMapLayerIdWmsTileGet(dashboardId, mapLayerId, crs, bbox, width, height, dimensionTime, dimensionReferenceTime, dimensionAircraftHeightAboveGroundLevelInFt, dimensionLevel, dimensionRiskProfile, options).then((request) => request(this.axios, this.basePath));
    }
}

